import { parseStoryPack, type StoryPack } from '@plotjack/core';
import storyJson from '../../../../packages/core/content/book1-story.json';

export const BOOK1_STORY: StoryPack = parseStoryPack(storyJson);
